/**
 * Generated by orval v8.5.3 🍺
 * Do not edit manually.
 * Space Invoices API
 * REST API for invoice management, customer management, and accounting operations. Features include cursor-based pagination for efficient data navigation, flexible JSON querying with MongoDB-style operators, full-text search across multiple fields, and comprehensive metadata support for custom tracking.
 * OpenAPI spec version: 1.0.0
 */

/**
 * Table to query
 */
export type StatsQueryRequestTable = typeof StatsQueryRequestTable[keyof typeof StatsQueryRequestTable];


export const StatsQueryRequestTable = {
  invoices: 'invoices',
  estimates: 'estimates',
  credit_notes: 'credit_notes',
  advance_invoices: 'advance_invoices',
  payments: 'payments',
  customers: 'customers',
  items: 'items',
  invoice_taxes: 'invoice_taxes',
} as const;
